import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {RolesService} from './roles-service';

@Injectable({providedIn: 'root'})
export class BackofficePermissionsService {
    private permissions: string[] = [];
    readonly permissions$ = new BehaviorSubject<string[]>([]);
    readonly permissionsLoaded$ = new BehaviorSubject<boolean>(false);
    private currentBackofficeId: string | null = null;

    constructor(private readonly rolesService: RolesService) {}

    /**
     * Returns the database id of the currently logged-in backoffice (Backoffice.Id), populated
     * after the bootstrap getMe() call. NOT the same as RolesService.getAccountId() which returns
     * the ADB2CObjectId from the token. Use this id to compare against ServiceDto.backoffices[*].id.
     */
    getCurrentBackofficeId(): string | null {
        return this.currentBackofficeId;
    }

    setPermissions(keys: string[]): void {
        this.permissions = keys;
        this.permissions$.next(keys);
        this.permissionsLoaded$.next(true);
    }

    setCurrentBackofficeId(id: string | null): void {
        this.currentBackofficeId = id;
    }

    hasPermission(key: string): boolean {
        if (this.rolesService.hasRoleSuperAdmin()) {
            return true;
        }

        return this.permissions.includes(key);
    }

    hasAnyPermission(keys: string[]): boolean {
        if (this.rolesService.hasRoleSuperAdmin()) {
            return true;
        }

        return keys.some(k => this.permissions.includes(k));
    }
}
